import type { ApiError, ApiErrorKind } from '@/api/client.types';

function kindOf(error: unknown): ApiErrorKind | undefined {
  return typeof error === 'object' && error !== null && 'kind' in error
    ? (error as ApiError).kind
    : undefined;
}

/**
 * A stats action's failure in words, from the error's kind alone. An
 * ApiError's message is the backend's whole error body (internal errors,
 * request dumps, student ids), so it is never shown.
 */
export function describeStatsFailure(error: unknown, failure: string): string {
  switch (kindOf(error)) {
    case 'auth':
      return `${failure} Sign in again, then try again.`;
    case 'permission':
      return `${failure} Only the course’s instructors can do this.`;
    case 'network':
      return `${failure} Check your connection and try again.`;
    default:
      return `${failure} Please try again.`;
  }
}

/**
 * The error a stats action throws for a failed call: the same kind, with words
 * for its message, since the chapter page shows a stats action's message as it
 * is.
 */
export function statsFailure(error: unknown, failure: string): ApiError {
  const replacement = new Error(describeStatsFailure(error, failure)) as ApiError;
  replacement.kind = kindOf(error) ?? 'data';
  return replacement;
}
